import { Button, Div, CollectionPrinter, RefBool, Span } from "@tblabs/truffle";
import { DeliveryForm } from "../../Models/Basket/DeliveryForm";
import { PaymentPresets } from "../../Models/OrderTicket/PaymentForm";
import { ReturnForm } from "../../Models/Basket/ReturnForm";
import { XRadioOption } from "./RadioOption";
import { FormSection } from "./RadioSection";
import { FormTextInputFullWidth, FormTextInputHalfWidth, FormMultilineInputFullWidth, FormSelectHalfWidth } from "./FormGroupFull";
import { MiniBasketItem } from "../MiniBasket/MiniBasketItem";
import { Notification } from "../Notification";
import { Box } from "../Utils/Box";
import { Center } from "../Utils/Center";
import { CryptoDiscount } from "../../Services/Basket/CryptoDiscount";
import { Page } from "../../Pages/Product/Page";
import { BasketProvider } from "../../Services/BasketProvider";
import { PageFooter } from "../../Pages/Main/PageFooter";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";
import { PrimaryButton } from "./PrimaryButton";
import { InfoBox } from "../../Pages/Product/InfoBox";
// local: #root > div.app > main > div > div:nth-child(3) > div > div.content > div > div:nth-child(2) > div:nth-child(6) > div > div > div:nth-child(8) > select
// prod:  #root > div.app > main > div > div:nth-child(3) > div > div:nth-child(2) > div:nth-child(6) > div > div > div:nth-child(8) > select
export class BasketPage extends Page
{
    constructor(_basket: BasketProvider, _shop: ShopContentProvider)
    {
        super("Koszyk");
        this.Class("summary-box")

        this.Content(async (body) =>
        {
            const basket = _basket.Basket;
            const basketBrain = _basket.BasketBrain;

            const cryptoDiscountValue = new CryptoDiscount().Value.value;

            body.Append(
                new Box(
                    new Center(
                        new InfoBox("Koszyk jest pusty", "Nie ma żadnych produktów w koszyku.\nDodaj produkty, aby kontynuować."),
                        new PrimaryButton("Dodaj produkty", () => window.location.hash = "/")
                    ),
                ).Visible(basket.WhenEmpty, "block"),

                new Box(
                    new FormSection("Twój koszyk", [
                        new CollectionPrinter(basket.Items, item => new MiniBasketItem(item, basket).Background("#1e293b")),
                    ]),

                    new FormSection("Sposób odbioru", [
                        new XRadioOption("DeliveryForm", basketBrain.DeliveryForm, DeliveryForm.Personal, "Odbiór osobisty", "Odbiór w Warszawie na Woli lub Służewiu", "Bezpłatnie"),
                        new XRadioOption("DeliveryForm", basketBrain.DeliveryForm, DeliveryForm.Package, "Kurier", "Dostawa pod wskazany adres (1-2 dni robocze)", basket.DeliveryCost),
                        new XRadioOption("DeliveryForm", basketBrain.DeliveryForm, DeliveryForm.Inpost, "Paczkomat [CHWILOWO NIEDOSTĘPNE]", "Dostawa na wskazany paczkomat", "1zł").Disabled(),
                    ]),

                    new FormSection("Zwrot", [
                        new XRadioOption("ReturnForm", basketBrain.ReturnForm, ReturnForm.Personal, "Zwrot osobisty", "Zwrot w Warszawie", "Bezpłatnie"),
                        new XRadioOption("ReturnForm", basketBrain.ReturnForm, ReturnForm.Package, "Paczkomat Inpost", "Zwrot do wybranego paczkomatu", "Na koszt nadawcy"),
                    ]).Visible(basket.IsAnythingToRent, "grid"),

                    new FormSection("Płatność", [
                        new XRadioOption("PaymentGroup1", basketBrain.PaymentForm, PaymentPresets.AllWithCash, "Gotówka", "Całość płatna gotówką przy odbiorze", undefined, "payment-option-cash")
                            .Enable(basketBrain.AllowCashPayment),
                        new XRadioOption("PaymentGroup1", basketBrain.PaymentForm, PaymentPresets.DepositWithBankTransfer_ServiceWithCash, "Przelew + gotówka", "Kaucja płatna przelewem, reszta płatna przy odbiorze", undefined, "payment-option-transfer-and-cash")
                            .Enable(basketBrain.AllowMixedPayment)
                            .Visible(basket.IsAnythingToRent, "flex"),
                        new XRadioOption("PaymentGroup1", basketBrain.PaymentForm, PaymentPresets.DepositWithBlik_ServiceWithCash, "Blik + gotówka", "Kaucja płatna Blikiem, reszta płatna przy odbiorze", undefined, "payment-option-transfer-and-cash")
                            .Enable(basketBrain.AllowMixedPayment)
                            .Visible(basket.IsAnythingToRent, "flex"),
                        new XRadioOption("PaymentGroup1", basketBrain.PaymentForm, PaymentPresets.AllWithCrypto, "Bitcoin", "Całość płatna z góry", cryptoDiscountValue + "% zniżki", "payment-option-crypto")
                            .Enable(basketBrain.AllowCryptoPayment),
                        new XRadioOption("PaymentGroup1", basketBrain.PaymentForm, PaymentPresets.AllWithBankTransfer, "Przelew [OPCJA TYMCZASOWO NIEDOSTĘPNA]", "Płatność całości przelewem", undefined, "payment-option-bank-transfer")
                            .Enable(new RefBool(false)),
                    ]).Visible(basket.IsAnythingToRent, "grid"),

                    new FormSection("Płatność", [
                        new XRadioOption("PaymentGroup2", basketBrain.PaymentForm, PaymentPresets.AllWithCash, "Gotówka", "Całość płatna gotówką przy odbiorze", undefined, "payment-option-cash")
                            .Enable(basketBrain.AllowCashPayment),
                        new XRadioOption("PaymentGroup2", basketBrain.PaymentForm, PaymentPresets.CashAtDelivery, "Pobranie", "Całość płatna przy odbiorze", undefined, "cash-at-delivery")
                            .Enable(basketBrain.AllowCashAtDelivery),
                        new XRadioOption("PaymentGroup2", basketBrain.PaymentForm, PaymentPresets.AllWithCrypto, "Bitcoin", "Całość płatna z góry", cryptoDiscountValue + "% zniżki", "payment-option-crypto")
                            .Enable(basketBrain.AllowCryptoPayment),
                        new XRadioOption("PaymentGroup2", basketBrain.PaymentForm, PaymentPresets.AllWithBankTransfer, "Przelew [OPCJA TYMCZASOWO NIEDOSTĘPNA]", "Płatność całości przelewem", undefined, "payment-option-bank-transfer")
                            .Enable(new RefBool(false)),
                    ]).Invisible(basket.IsAnythingToRent, "grid"),

                    new FormSection("Dane do wysyłki", [
                        new Div("form").Append(
                            new FormTextInputFullWidth("Imię i nazwisko", basketBrain.Customer.Name),
                            new FormTextInputFullWidth("Adres", basketBrain.Customer.Address.Street),
                            new FormTextInputHalfWidth("Miasto", basketBrain.Customer.Address.City),
                            new FormTextInputHalfWidth("Kod pocztowy", basketBrain.Customer.Address.PostalCode),
                            new FormTextInputHalfWidth("Telefon", basketBrain.Customer.Phone),
                            new FormTextInputHalfWidth("E-mail", basketBrain.Customer.Email),
                            new FormTextInputFullWidth("Numer konta do zwrotu kaucji", basketBrain.Customer.DepositAccount, "Bez niego nie będziemy w stanie jej zwrócić!")
                                .Visible(basketBrain.ShowCustomerDepositAccountInput, "flex"),
                            new FormSelectHalfWidth("Doświadczenie", basketBrain.Customer.Experience, {
                                "🥔 Jestem osobą totalnie atechniczną": 1,
                                "🥉 Radzę sobie z technologią": 2,
                                "🥈 Znam podobny sprzęt": 3,
                                "🥇 Znam Wasz sprzęt": 4
                            }),
                            new FormSelectHalfWidth("Skąd o nas wiesz?", basketBrain.Customer.Origin, {
                                "Proszę coś wybrać...": "brak informacji",
                                "Od znajomych": "Od znajomych",
                                "Facebook": "Facebook",
                                "Instagram": "Instagram",
                                "Google": "Google",
                                "Youtube": "Youtube",
                                "OLX": "OLX", "Allegro": "Allegro",
                                "Ulotki": "Ulotki",
                                "TikTok": "TikTok",
                                "Inne": "Inne"
                            }),
                            new FormMultilineInputFullWidth("Uwagi do zamówienia", basketBrain.Notes, "Jeśli potrzebujesz dodatkowej pomocy, wpisz szczegóły tutaj"),
                        ),
                    ]),

                    new Center(
                        new PrimaryButton("Przejdź do podsumowania")
                            .Enable(basketBrain.IsValid)
                            .OnClick(() =>
                            {
                                if (basketBrain.Customer.IsValid)
                                {
                                    window.location.hash = "koszyk/podsumowanie";
                                }
                                else new Notification("Wypełnij wszystkie pola", "Aby przejść do podsumowania należy wypełnić wszystkie pola");
                            })
                    ).MarginTop(16),
                ).VisibleWhen(basket.WhenEmpty, v => !v, "block")
            )
        });

        this.Append(new PageFooter(_shop));
    }
}
